<!--


FALTA:

- receber os valores padrao dos filtros
- tratar o filtro data de referencia - selecionar uma data
- tratar o filtro mes de referencia - selecionar o mes combobox



consultas com data de referencia -> abrir campo data referencia na consulta e botao "+ filtros"
consultas com mes de referencia -> abrir campo mes referencia na consulta e botao "+ filtros"




/*
            params: {

                periodo: {
                    label: 'Data da venda',
                    varios: false,
                    data_inicio: null,
                    data_termino: null,
                },

                mes_referencia: {
                    label: 'Data da venda',
                    value: null,
                },

                data_referencia: {
                    label: 'Data da venda',
                    value: null,
                },

                filtros: [
                    { nome: 'filial', label: null, url: null, varios: false, values: [] },
                    { nome: 'segmento', label: null, url: null, varios: true, values: [] },
                    { nome: 'grupocliente', label: null, url: null, varios: true, values: [] },
                    { nome: 'estado', label: null, url: null, varios: true, values: [] },
                    { nome: 'grupoestoque', label: null, url: null, varios: true, values: [] },
                ],

                combobox: [

                ],

                checkbox: [
                    { nome: 't1', label: 'Teste1', valueChecked: 'S', valueUnckecked: 'N', value: 'S', },
                    { nome: 't2', label: 'Teste2', valueChecked: 'S', valueUnckecked: 'N', value: 'S', },
                    { nome: 't3', label: 'Teste3', valueChecked: 'S', valueUnckecked: 'N', value: 'S', },
                ]

            },
*/


 -->







<template>
  <div class="filtro-bar" :style="showClass">
    <div class="filtro-bar-inner filtro-bar-sombra">

      <div class="filtro-bar-body" style="">

        <div class="row" v-if="params.periodo">
          <div class="col-md-12 col-12 mb-3">
            <span class="lbl-deal-subtitle">Período</span>
          </div>
        </div>

        <div class="row mb-3" v-if="params.periodo">
          <div class="col-md-12 col-12">
            <v-label :label="params.periodo.label"></v-label>
          </div>
          <div class="col-md-12 col-12 d-flex" v-for="(periodo, index) in filtroPeriodos" :key="index">
            <input-month2 :p-month="periodo" @monthChange="handlePeriodoChange(index)"></input-month2>
            <v-button v-if="filtroPeriodos.length > 1" class="ml-3" icon="fa-trash" :link="true"
              @click="handleExcluiPeriodo(index)"></v-button>
            <v-button v-if="params.variosPeriodos && index == filtroPeriodos.length - 1" label="Adicionar" class="ml-3"
              icon="fa-plus" :link="true" @click="handleAdicionaPeriodo"></v-button>
          </div>
          <div v-if="params.periodo.varios" class="col-md-12 col-12">
            <v-button label="Adicionar Período" icon="fa-plus" :link="true" @click="handleAdicionaPeriodo"></v-button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-12 mb-3">
            <span class="lbl-deal-subtitle">Filtros</span>
          </div>
        </div>

        <div class="mb-2" v-for="(flt, index) in filtros" :key="index">
          <div class="row" v-for="(value, index2) in flt.values" :key="index2">
            <div class="col-10">
              <form-field v-model="value.id" type="select2" :select2="{ entity: flt.url, minlength: 0 }"
                :placeholder="flt.label"></form-field>
            </div>
            <div class="col-2">
              <v-button v-show="flt.values.length > 1" icon="fa-trash" :link="true"
                @click="handleExcluiValueFiltro(flt, index2)"></v-button>
            </div>
          </div>
          <div v-if="flt.varios" class="row mb-4">
            <div class="col-md-12 col-12">
              <v-button label="Adicionar" icon="fa-plus" :link="true" @click="handleAdicionaFiltro(flt)"></v-button>
            </div>
          </div>
        </div>

        <div v-for="(check, index) in params.checkbox" :key="index">
          <div class="row">
            <div class="col-md-12 col-12">
              <input-checkbox v-model="check.value" :label="check.label" :value-checked="check.valueChecked"
                :value-unchecked="check.valueUnchecked"></input-checkbox>
              <!-- <input-switch type="success" :label="check.label" :value-checked="check.valueChecked" :value-unchecked="check.valueUnchecked"></input-switch> -->
            </div>
          </div>
        </div>
        <div v-for="(select, index) in params.selects" :key="index">
          <div class="row">
            <div class="col-md-12 col-12">
              <select name="" id="" class="form-control select">
                <option value="" disabled selected>{{ select.placeholder }}</option>
                <option value=""></option>
                <option v-for="(op, i ) in select.options" :key="i" :value="op.id">{{ op.label }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- <div class="row">
            <form-field v-model="codusuario" type="select" col="4" :select-options="usuarioList" placeholder="Todos os usuários"></form-field>
            <form-field v-model="codusuario" type="select" col="4" placeholder="Todos os usuários"></form-field>
        </div> -->

      </div>
      <div class="filtro-bar-footer">
        <v-button label="Ok" @click="change"></v-button>
        <v-button label="Cancelar" @click="cancel"></v-button>
      </div>

    </div>
  </div>

</template>

<script>
// import DashCard from '../components/dash-card'

export default {
  props: {
    params: { type: Object },
    showfiltro: { type: Boolean }
  },

  components: {

  },

  data() {
    return {


      base: {
        usuario: { label: 'Usuario', url: 'usuario', tipo: 'select2', varios: false, values: [{ id: null }] },
        equipe: { label: 'Equipe de Venda', url: '', tipo: 'select2', varios: false, values: [{ id: null }] },
        filial: { label: 'Filial', url: 'filial/', tipo: 'select2', varios: false, values: [{ id: null }] },
        segmento: { label: 'Segmento', url: 'ramoat/', tipo: 'select2', varios: false, values: [{ id: null }] },
        grupocliente: { label: 'Grupo de Clientes', url: 'grucli/', tipo: 'select2', varios: false, values: [{ id: null }] },
        cliente: { label: 'Cliente', url: 'cliente/', tipo: 'select2', varios: false, values: [{ id: null }] },
        clienteusuario: { label: 'Cliente', url: 'clienteusuario/', tipo: 'select2', varios: false, values: [{ id: null }] },
        clientefornecedor: { label: 'Cliente / Fornecedor', url: 'clientefornecedor/', tipo: 'select2', varios: false, values: [{ id: null }] },
        fornecedor: { label: 'Fornecedor', tipo: 'select2', varios: false, values: [{ id: null }] },
        estado: { label: 'Estado', url: 'estado/', tipo: 'select2', varios: false, values: [{ id: null }] },
        cidade: { label: 'Cidade', url: 'mun/', tipo: 'select2', varios: false, values: [{ id: null }] },
        grupoestoque: { label: 'Grupo de Produtos', url: 'gruest/', tipo: 'select2', varios: false, values: [{ id: null }] },
        produto: { label: 'Produto', url: 'item/', tipo: 'select2', varios: false, values: [{ id: null }] },
        formapagamento: { label: 'Forma de Pagamento', url: 'fpag/', tipo: 'select2', varios: false, values: [{ id: null }] },
        pdstatus: { label: 'Status do Pedio', url: 'pdstatus/', tipo: 'select2', varios: false, values: [{ id: null }] },
        // texto: { label: 'Texto', tipo: 'text', varios: false, values: [{ text: null }] },
      },

      filtros: [

      ],

      filtroPeriodos: [
        { data_inicio: null, data_termino: null, startDate: null, endDate: null }
      ],

    }
  },

  watch: {
  },

  methods: {
    inicializa() {
      let obj = null

      for (var x = 0; x < this.params.filtros.length; x++) {

        obj = this.base[this.params.filtros[x].nome]
        obj.nome = this.params.filtros[x].nome

        if (this.params.filtros[x].label)
          obj.label = this.params.filtros[x].label

        if (this.params.filtros[x].url)
          obj.url = this.params.filtros[x].url

        if (this.params.filtros[x].varios)
          obj.varios = this.params.filtros[x].varios

        //aqui carrega os valores para os filtros vindos do PARENT
        if (this.params.filtros[x].values && this.params.filtros[x].values.length > 0) {
          obj.values = []
          for (var y = 0; y < this.params.filtros[x].values.length; y++) {
            obj.values.push({ id: this.params.filtros[x].values[y] })
          }
          // console.log(obj.values)
        }
        //

        this.filtros.push(obj)
      }


      if (this.params.periodos)
        this.filtroPeriodos = this.params.periodos
      else
        if (this.params.periodo) {
          this.filtroPeriodos = [
            {
              data_inicio: this.params.periodo.data_inicio,
              data_termino: this.params.periodo.data_termino,
              startDate: this.params.periodo.data_inicio,
              endDate: this.params.periodo.data_termino,
            }
          ]
        }


      /*
      query string
      datainicial=99-99-9999&datafinal=99-99-9999&filial=1&grupoestoque=1&grupocliente=1
      */

    },


    readQueryString() {


    },


    createQueryString() {


    },


    change() {
      let filtro = {}

      let periodos = []

      for (var x = 0; x < this.filtroPeriodos.length; x++) {
        this.filtroPeriodos[x].data_inicio = this.filtroPeriodos[x].startDate
        this.filtroPeriodos[x].data_termino = this.filtroPeriodos[x].endDate
        periodos.push(this.filtroPeriodos[x])
      }

      filtro.periodos = periodos

      this.params.periodos = periodos //atualiza os periodos no objeto pai

      let obj = null
      let values = null

      for (var x = 0; x < this.filtros.length; x++) {
        values = []
        for (var y = 0; y < this.filtros[x].values.length; y++) {
          if (this.filtros[x].values[y].id)
            values.push(this.filtros[x].values[y].id)
        }
        filtro[this.filtros[x].nome] = values
      }

      if (this.params.checkbox && this.params.checkbox.length) {
        for (var x = 0; x < this.params.checkbox.length; x++) {
          filtro[this.params.checkbox[x].nome] = this.params.checkbox[x].value
        }
      }


      this.$modalForm(false)

      console.log(filtro)

      this.$emit('change', filtro)
    },

    async cancel() {
      this.$emit('cancel')
    },

    handlePeriodoChange(index) {
      //alteracao de periodo
    },

    handleAdicionaFiltro(flt, index) {
      flt.values.push({ id: null })

    },

    handleAdicionaPeriodo() {
      this.filtroPeriodos.push({ data_inicio: null, data_termino: null, startDate: null, endDate: null })

      // console.log(this.$route.query)

      // let query = JSON.parse(JSON.stringify(this.$route.query));
      // query.segmento = [1]

      // // this.$router.replace({ query: query })
      // window.location.hash = '#/?segmento=5'
      // console.log(window.location.hash.slice(1))

    },

    handleExcluiPeriodo(index) {
      this.filtroPeriodos.splice(index, 1)
    },


    handleExcluiValueFiltro(flt, index) {
      flt.values.splice(index, 1)
    },

    async loadData() {
      //CARREGA DADOS DA SESSAO
      await this.$store.dispatch('loadSessao', this)

      //CARREGA LISTA DE USUARIOS
      await this.$store.dispatch('loadUsuariosDashboard', this)
    }

  },

  computed: {
    showClass: function () {
      if (!this.showfiltro) {
        this.$modalForm(false)
        return 'transform: translate3d(0, 100%, 0);'
      }
      else {
        this.$modalForm(true)
        return 'transform: translate3d(0%, 0, 0);'
      }
    },

    sessao: function () {
      return this.$store.getters.getSessao
    },

  },

  destroyed() {
    this.$modalForm(false)
  },

  mounted() {

    let vm = this
    this.keytimer = setTimeout(function () {
      // console.log(vm.filtros)
    }, 100);

  },

  created() {

    this.inicializa()
  }

}
</script>

<style>
.select {
  height: 30px;
  font-size: 14px;
  padding: 3px;
}

.filtro-bar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translate3d(100%, 0, 0);
  transition: all .35s;
  will-change: transform;
  z-index: 10000;
}

.filtro-bar-sombra {
  box-shadow: 0 0 32px 0 #a9aaac80;
}

.filtro-bar-inner {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
  height: 100%;
}


@media (max-width: 768px) {
  .filtro-bar-inner {
    width: 90vw;
  }


}

.filtro-bar-footer {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px 20px;
  flex: 0 0 78px;
}


.filtro-bar-body {
  padding: 1rem !important;
  overflow-y: auto;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/consultas/filtro.vue